export const getToken = () => localStorage.getItem('@Plantao:token');

export const getUser = () => JSON.parse(localStorage.getItem('@Plantao:user'));
